import { Card } from "../Card"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

const TimelineItemsSkeleton = (props: { count: number }) => {
  const skeletonCards = []
  for (let i = 0; i < props.count; i++) {
    skeletonCards.push(<SkeletonCard key={`tisk-${i}`} />)
  }
  return <>{skeletonCards}</>
}

export const SkeletonCard = () => (
  <div className="module activity-list mb-1 p-4 pointer" role="status">
    <div className="d-none d-md-flex activity-time">
      <p className="text-meta">
        <Skeleton height="1.2rem" width="10rem" />
      </p>
    </div>
    <div className="flex-row">
      <div className="d-none d-md-block activity-type">
        <Skeleton height="1.5rem" />
      </div>
      <div className="activity">
        <div className="row-center justify-content-between">
          <div className="d-flex">
            <div className="mr-2 avatar small borderless">
              <Skeleton circle={true} />
            </div>
            <div className="text-ellipsis">
              <h5 className="text-ellipsis">
                <Skeleton width="8rem" height="1rem" />
              </h5>
              <small className="text-meta text-ellipsis">
                <Skeleton />
              </small>
            </div>
          </div>
          <div style={{ fontWeight: "500" }}></div>
        </div>
        <div className="mt-1">
          <p>
            <Skeleton height="1.5rem" width="20rem" />
          </p>
        </div>
      </div>
      <div className="vertical-center">
        <i className="icon-font tc-icon-chevron-right"></i>
      </div>
    </div>
  </div>
)

export default TimelineItemsSkeleton
